import axios from "../axiosConfig";
import { ENDPOINT_BRANCH_ADD, ENDPOINT_BRANCH_REMOVE, ENDPOINT_BRANCH_UPDATE, ENDPOINT_BRANCHES_RETRIEVE, ENDPOINT_USER_BRANCH_ADD, ENDPOINT_USER_BRANCH_REMOVE, ENDPOINT_USER_BRANCH_RETRIEVE } from "../../constants";

// use to retrieve branches
export function retrieveBranches(com:string) : Promise<any> {
    return new Promise<any>( async (resolve, reject) => {
        axios.get(ENDPOINT_BRANCHES_RETRIEVE + "?com=" + com, {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

// use to add branch
export function addBranch(id:string,name:string,com:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_BRANCH_ADD, {
            branchid:id,
            name:name,
            com:com
        }, {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

// function to remove branch
export function removeBranch(id:string,com:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_BRANCH_REMOVE+"?com="+com+"&id="+id, {},
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function updateBranch(id:string,com:string, name:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_BRANCH_UPDATE, {
            id: id,
            com: com,
            name: name,
        },
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function addUserBranch(userid:string,com:string, branch:string, servicing:boolean) : Promise<any> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_USER_BRANCH_ADD, {
            userid: userid,
            com: com,
            branch: branch,
            servicing: servicing,
        },
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function removeUserBranch(com:string, userid:string, branchid:string ) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_USER_BRANCH_REMOVE, {
            com: com,
            userid: userid,
            branch: branchid
        },
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function retrieveUserBranches(com:string,userid:string,offset=0) : Promise<any> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_USER_BRANCH_RETRIEVE, {
            com: com,
            userid: userid,
            offset: offset,
        },
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}